import { useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, BadgeCheck } from "lucide-react";
import { useLang } from "@/context/AppContext";
import { useLiveEvent } from "@/context/RealtimeContext";
import { useApi } from "@/lib/useApi";

const MEDAL = ["text-yellow-300", "text-slate-300", "text-orange-400"];

export const CommunityRanking = ({ cid }) => {
  const { t } = useLang();
  const [tab, setTab] = useState("trusted");
  const { data, reload: load } = useApi(`/communities/${cid}/ranking`);
  useLiveEvent(["community_update"], (m) => m.data.community_id === cid && load());
  if (!data) return null;
  const rows = data[tab];
  return (
    <section className="rounded-md border border-white/[0.08] bg-[#111827] p-6" data-testid="community-ranking">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-yellow-300"><Trophy className="h-4 w-4" />{t("ranking")}</p>
      <p className="mt-1 font-mono text-[10px] text-slate-500">{t("week_of")} {new Date(data.week_start).toLocaleDateString()}</p>
      <div className="mt-4 flex gap-2">
        {[["trusted", "rank_trust"], ["followed", "rank_followers"]].map(([k, l]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`ranking-tab-${k}`}
            className={`rounded-full px-3 py-1 text-xs transition-colors ${tab === k ? "bg-emerald-400/10 text-emerald-300" : "text-slate-400 hover:text-white"}`}>{t(l)}</button>
        ))}
      </div>
      <ol className="mt-4 space-y-2">
        {!rows.length && <li className="text-sm text-slate-500">{t("empty")}</li>}
        {rows.map((r, i) => (
          <li key={r.user_id} className="flex items-center gap-3" data-testid={`ranking-row-${tab}-${i}`}>
            <span className={`w-6 font-display text-lg font-bold ${MEDAL[i] || "text-slate-600"}`}>{i + 1}</span>
            <span className="min-w-0 flex-1 truncate text-sm text-white">
              {r.top_principal_id ? <Link to={`/app/profiles/${r.top_principal_id}`} className="hover:text-emerald-300">{r.name}</Link> : r.name}
              {r.verified && <BadgeCheck className="ml-1 inline h-3.5 w-3.5 text-emerald-400" />}
            </span>
            {tab === "trusted"
              ? <span className="font-display text-lg font-bold text-emerald-300">{r.trust}</span>
              : <span className="text-right"><span className="font-display text-lg font-bold text-cyan-300">+{r.new_followers}</span><span className="block font-mono text-[10px] text-slate-500">{r.followers} {t("followers")}</span></span>}
          </li>
        ))}
      </ol>
    </section>
  );
};
